/* ===========================================================================
   SALON · 2D Gallery Wall  (progressive-enhancement layer over the 3D salon)
   ---------------------------------------------------------------------------
   Goals (client-side, reuses the existing window.Shop detail/cart flow):
     • "Browse as gallery wall / Skip intro" toggle  -> flat, scrollable grid
     • crawlable real DOM: <h1>/<h2>/<img alt>/prices live in the page
     • price + Collect on hover/tap, per card
     • "Limited edition of 10" honest scarcity label
     • loading-screen thumbnail carousel instead of a blank wait
     • mobile: default to the gallery wall (no WASD / drag-to-look)
   Each card -> window.Shop.openDetail(art) (the click-through detail view);
   Collect   -> window.Shop.addToCart(art.id) (same cart as the 3D salon).
   =========================================================================== */
(function(){
"use strict";

var IS_TOUCH = false;
try{
  IS_TOUCH = window.matchMedia &&
    (window.matchMedia('(pointer:coarse)').matches || window.matchMedia('(max-width:820px)').matches);
}catch(e){}

/* ---------- styles ---------- */
function injectCSS(){
  if(document.getElementById('salon-wall-css')) return;
  var s=document.createElement('style'); s.id='salon-wall-css';
  s.textContent=[
    '.wall-toggle{display:inline-flex;align-items:center;gap:6px;cursor:pointer}',
    '#salon-wall{position:fixed;inset:0;z-index:60;background:#0b0b0d;color:#f4f1ea;',
      'overflow-y:auto;-webkit-overflow-scrolling:touch;display:none;font-family:inherit}',
    '#salon-wall.show{display:block}',
    '#salon-wall .wall-top{position:sticky;top:0;z-index:2;display:flex;align-items:center;',
      'justify-content:space-between;gap:12px;padding:16px 22px;',
      'background:linear-gradient(180deg,rgba(11,11,13,.96),rgba(11,11,13,.78));',
      'backdrop-filter:blur(8px);border-bottom:1px solid rgba(255,255,255,.08)}',
    '#salon-wall .wall-h1{font-size:18px;letter-spacing:.18em;font-weight:600;margin:0}',
    '#salon-wall .wall-h1 small{display:block;font-size:11px;letter-spacing:.22em;',
      'opacity:.55;font-weight:400;margin-top:3px}',
    '#salon-wall .wall-actions{display:flex;align-items:center;gap:10px}',
    '#salon-wall .wall-btn{cursor:pointer;border:1px solid rgba(255,255,255,.18);',
      'background:transparent;color:#f4f1ea;border-radius:999px;padding:9px 16px;',
      'font:inherit;font-size:13px;letter-spacing:.04em}',
    '#salon-wall .wall-btn.primary{background:var(--ac,#2962FF);border-color:transparent;color:#fff}',
    '#salon-wall .wall-btn:hover{border-color:rgba(255,255,255,.4)}',
    '#salon-wall .wall-body{padding:26px 22px 64px;max-width:1320px;margin:0 auto}',
    '#salon-wall .wall-sec{margin:0 0 14px;display:flex;align-items:baseline;gap:12px;',
      'border-bottom:1px solid rgba(255,255,255,.08);padding-bottom:8px;margin-top:34px}',
    '#salon-wall .wall-sec h2{font-size:20px;margin:0;font-weight:600;letter-spacing:.01em}',
    '#salon-wall .wall-sec .cnt{font-size:12px;opacity:.5;letter-spacing:.08em}',
    '#salon-wall .wall-blurb{font-size:13px;opacity:.6;margin:0 0 16px;max-width:62ch;line-height:1.5}',
    '#salon-wall .grid{display:grid;gap:18px;',
      'grid-template-columns:repeat(auto-fill,minmax(min(100%,240px),1fr))}',
    '.wcard{position:relative;background:#121216;border:1px solid rgba(255,255,255,.07);',
      'border-radius:14px;overflow:hidden;cursor:pointer;transition:transform .18s,border-color .18s}',
    '.wcard:hover{transform:translateY(-3px);border-color:rgba(255,255,255,.22)}',
    '.wcard .frame{position:relative;aspect-ratio:1/1;background:#1a1a20;overflow:hidden}',
    '.wcard .frame img{width:100%;height:100%;object-fit:cover;display:block;',
      'transition:transform .4s ease}',
    '.wcard:hover .frame img{transform:scale(1.045)}',
    '.wcard .ed{position:absolute;top:10px;left:10px;font-size:10px;letter-spacing:.12em;',
      'text-transform:uppercase;background:rgba(0,0,0,.55);backdrop-filter:blur(4px);',
      'padding:5px 9px;border-radius:999px;border:1px solid rgba(255,255,255,.16)}',
    '.wcard .body{padding:13px 14px 15px}',
    '.wcard .t{font-size:15px;font-weight:600;margin:0 0 2px;line-height:1.25}',
    '.wcard .c{font-size:11.5px;opacity:.55;letter-spacing:.06em;margin:0 0 10px}',
    '.wcard .row{display:flex;align-items:center;justify-content:space-between;gap:8px}',
    '.wcard .p{font-size:11px;font-weight:500;letter-spacing:.06em;opacity:.55;text-transform:uppercase}',
    '.wcard .collect{cursor:pointer;border:0;border-radius:999px;padding:8px 14px;',
      'font:inherit;font-size:12.5px;font-weight:600;letter-spacing:.03em;',
      'background:var(--ac,#2962FF);color:#fff;opacity:0;transform:translateY(4px);',
      'transition:opacity .16s,transform .16s}',
    '.wcard:hover .collect,.wcard:focus-within .collect{opacity:1;transform:none}',
    '@media (pointer:coarse){.wcard .collect{opacity:1;transform:none}}',
    '.wall-empty{opacity:.6;padding:40px 0;text-align:center}',
    /* prices live on the product page now — hide the always-on 3D commerce-bar price */
    '.combar .price{display:none!important}',
    /* loader carousel */
    '#boot .boot-carousel{display:flex;gap:8px;justify-content:center;margin-top:22px;',
      'height:54px;overflow:hidden}',
    '#boot .boot-carousel .bc{width:54px;height:54px;border-radius:9px;background-size:cover;',
      'background-position:center;opacity:0;transform:scale(.9);',
      'transition:opacity .5s,transform .5s;border:1px solid rgba(255,255,255,.12)}',
    '#boot .boot-carousel .bc.on{opacity:.9;transform:none}'
  ].join('');
  document.head.appendChild(s);
}

/* ---------- helpers ---------- */
function fmt(p){ try{ return window.Shop&&window.Shop.fmt?window.Shop.fmt(p):('$'+p); }catch(e){ return '$'+p; } }
function esc(t){ try{ return window.Shop&&window.Shop.esc?window.Shop.esc(t):(''+t); }
  catch(e){ return (''+t).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); } }
function ART(){ return window.ART||[]; }
function COLLS(){ return window.COLLECTIONS||(window.Shop&&window.Shop.COLL)||{}; }

/* ---------- build the wall ---------- */
var built=false;
function buildWall(){
  if(built) return; var art=ART(); if(!art.length) return;

  /* De-duplicate the grid: some pieces (e.g. the Impermanent Loss "(Variant)"
     works) reuse the SAME image as their base piece, which makes the same
     artwork appear two-to-four times in one grid. Collapse every group that
     shares an image down to a single card, preferring the non-"Variant"
     title so the canonical piece is the one shown. */
  (function(){
    var bestByImg={};
    art.forEach(function(a){
      var k=a.full||a.thumb||a.id;
      var cur=bestByImg[k];
      if(!cur){ bestByImg[k]=a; return; }
      var aVar=/variant/i.test(a.title||''), curVar=/variant/i.test(cur.title||'');
      if(curVar && !aVar) bestByImg[k]=a; /* prefer the canonical (non-variant) piece */
    });
    var keep=[]; for(var k in bestByImg){ keep.push(bestByImg[k]); }
    art=art.filter(function(a){ return keep.indexOf(a)!==-1; });
  })();

  injectCSS();
  var wrap=document.createElement('section'); wrap.id='salon-wall';
  wrap.setAttribute('aria-label','MLOW · The Salon gallery wall');

  var top=document.createElement('div'); top.className='wall-top';
  top.innerHTML=
    '<h1 class="wall-h1">MLOW · The Salon<small>'+art.length+' works · 11 rooms · limited editions</small></h1>'+
    '<div class="wall-actions">'+
      '<button class="wall-btn enter3d" type="button">Enter the 3D salon</button>'+
      '<button class="wall-btn primary closewall" type="button">Done</button>'+
    '</div>';
  wrap.appendChild(top);

  var body=document.createElement('div'); body.className='wall-body';

  // group by collection (meaningful, SEO-friendly headings)
  var colls=COLLS(), order=[], seen={};
  art.forEach(function(a){ if(!seen[a.coll]){ seen[a.coll]=1; order.push(a.coll); } });

  order.forEach(function(code){
    var items=art.filter(function(a){ return a.coll===code; });
    if(!items.length) return;
    var cmeta=colls[code]||{}, name=items[0].collName||cmeta.name||code;
    var sec=document.createElement('div');
    var cards=items.map(function(a){
      return '<article class="wcard" data-id="'+esc(a.id)+'" tabindex="0">'+
        '<div class="frame"><span class="ed">Limited edition of '+(a.edition||10)+' per format</span>'+
        '<img src="'+esc(a.thumb||a.full)+'" referrerpolicy="no-referrer" loading="lazy" alt="'+esc(a.title)+' · '+esc(name)+'"></div>'+
        '<div class="body"><h3 class="t">'+esc(a.title)+'</h3><div class="c">'+esc(name)+' · '+esc(a.id)+'</div>'+
        '<div class="row"><span class="p">Limited · signed &amp; numbered</span>'+
        '<button class="collect" type="button" data-collect="'+esc(a.id)+'">Collect</button></div></div>'+
      '</article>';
    }).join('');
    sec.innerHTML=
      '<div class="wall-sec"><h2>'+esc(name)+'</h2><span class="cnt">'+items.length+' works</span></div>'+
      (cmeta.blurb?'<p class="wall-blurb">'+esc(cmeta.blurb)+'</p>':'')+
      '<div class="grid">'+cards+'</div>';
    body.appendChild(sec);
  });

  wrap.appendChild(body);
  document.body.appendChild(wrap);

  // interactions (delegated)
  wrap.addEventListener('click',function(e){
    if(e.target.closest('.closewall')){ hideWall(); return; }
    if(e.target.closest('.enter3d')){ hideWall(); return; }
    var col=e.target.closest('[data-collect]');
    if(col){ e.stopPropagation(); collect(col.getAttribute('data-collect')); return; }
    var card=e.target.closest('.wcard');
    if(card){ openDetail(card.getAttribute('data-id')); }
  });
  wrap.addEventListener('keydown',function(e){
    if(e.key==='Enter'){ var card=e.target.closest&&e.target.closest('.wcard');
      if(card){ openDetail(card.getAttribute('data-id')); } }
    if(e.key==='Escape'){ hideWall(); }
  });

  built=true;
}

function artById(id){
  if(window.Shop&&window.Shop.ART_BY_ID&&window.Shop.ART_BY_ID[id]) return window.Shop.ART_BY_ID[id];
  return ART().filter(function(a){return a.id===id;})[0];
}
function openDetail(id){
  var a=artById(id); if(a&&window.Shop&&window.Shop.openDetail) window.Shop.openDetail(a);
}
function collect(id){
  // Real purchase: send the visitor to the live Shopify product page,
  // where they pick size + material and add to the real cart.
  var a=artById(id);
  var url=(window.Shop&&typeof window.Shop.productUrl==='function')?window.Shop.productUrl(a):null;
  if(url){ try{ window.location.assign(url); }catch(e){ window.location.href=url; } return; }
  // fallback: open the detail view (its button also links to the product page)
  openDetail(id);
}

/* ---------- show / hide ---------- */
function showWall(){ buildWall(); var w=document.getElementById('salon-wall'); if(w){ w.classList.add('show'); document.documentElement.style.overflow='hidden'; } }
function hideWall(){ var w=document.getElementById('salon-wall'); if(w){ w.classList.remove('show'); document.documentElement.style.overflow=''; } }

/* ---------- topbar toggle ---------- */
function addToggle(){
  var tr=document.querySelector('.topright'); if(!tr || tr.querySelector('.wall-toggle-btn')) return;
  var b=document.createElement('button');
  b.className='iconbtn wall-toggle-btn'; b.type='button'; b.title='Browse as a gallery wall';
  b.innerHTML='<span class="ph">&#9638;</span> Wall';
  b.addEventListener('click',function(e){ e.preventDefault(); showWall(); });
  // place it just before the Rooms button if present, else append
  var rooms=tr.querySelector('.rooms-btn');
  if(rooms) tr.insertBefore(b,rooms); else tr.appendChild(b);
}
(function watchTopbar(){
  if(document.querySelector('.topright')){ addToggle(); return; }
  setTimeout(watchTopbar,200);
})();

/* ---------- loader thumbnail carousel ---------- */
(function loaderCarousel(){
  var boot=document.getElementById('boot'); if(!boot) return;
  var art=ART(); if(!art.length){ setTimeout(loaderCarousel,150); return; }
  if(boot.querySelector('.boot-carousel')) return;
  // pick up to 7 spread-out thumbnails
  var picks=[], step=Math.max(1,Math.floor(art.length/7));
  for(var i=0;i<art.length&&picks.length<7;i+=step) picks.push(art[i]);
  var strip=document.createElement('div'); strip.className='boot-carousel';
  strip.innerHTML=picks.map(function(a){
    return '<div class="bc" style="background-image:url('+(a.thumb||a.full)+')"></div>';
  }).join('');
  // append after the sub-line
  (boot.querySelector('.boot-sub')||boot).insertAdjacentElement('afterend',strip);
  var cells=strip.querySelectorAll('.bc'), n=0;
  function tick(){
    if(!document.body.contains(strip)) return; // boot removed -> stop
    cells.forEach(function(c,k){ c.classList.toggle('on', k<=n%cells.length); });
    n++; setTimeout(tick,420);
  }
  tick();
})();

/* ---------- mobile: default to the gallery wall ---------- */
(function mobileDefault(){
  if(!IS_TOUCH) return;
  try{ if(sessionStorage.getItem('salon_wall_dismissed')) return; }catch(e){}
  function tryOpen(){
    if(ART().length){ showWall(); return; }
    setTimeout(tryOpen,250);
  }
  // wait until past the boot screen
  var boot=document.getElementById('boot');
  if(boot){
    var obs;
    try{
      obs=new MutationObserver(function(){
        var hidden=boot.classList.contains('done')||getComputedStyle(boot).display==='none'||boot.style.opacity==='0';
        if(hidden){ obs.disconnect(); tryOpen(); }
      });
      obs.observe(boot,{attributes:true});
    }catch(e){}
    // safety: open after a few seconds regardless
    setTimeout(tryOpen,4200);
  }else{
    tryOpen();
  }
})();
// remember if the visitor leaves the wall on mobile, so we don't force it again this session
document.addEventListener('click',function(e){
  if(e.target.closest&&e.target.closest('.closewall,.enter3d')){
    try{ sessionStorage.setItem('salon_wall_dismissed','1'); }catch(e){}
  }
},true);

})();
